class HomeSlider extends Component {
	constructor(el) {
		super(el);
		this.swiperEl = this.$find('[data-swiper]');
		this.swiper = null;
		this.swiperEl && this.constructSwiper();
	}

	constructSwiper() {
		this.swiper = new Swiper(this.swiperEl, {
			watchOverflow: true,
			pagination: {
				el: '[data-home-pagination]',
				clickable: true
			},
			autoplay: {
				delay: 10000
			}
		});
	}
}
